import React, { Fragment, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const DomainsList = () =>{
    const { pubId } = useParams(); // Get publisher ID from URL
    const navigate = useNavigate();
    const [domainList, setDoaminList] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const alldomainList = async () =>{
      try {
            const token = localStorage.getItem("token");
            const alldomainListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllSites/${pubId}`, {
                    headers : {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
              );
                console.log(alldomainListRes);
                if(alldomainListRes.status === 200){
                    setDoaminList(alldomainListRes.data.data);
                }else {
                  setMessage("No domains found.");
                }
        } catch (error) {
          if (error.alldomainListRes?.status === 401) {
            console.error("Unauthorized! Token might be expired.");
            localStorage.removeItem("token");
            navigate("/");
          } else {
            console.error("Error fetching data:", error);
          }
          setMessage("Error fetching domain list.");
        } finally {
            setLoading(false);
          }
        
    } 

    useEffect(() => {
        alldomainList();
  }, [pubId]);

  return (
    <section className="mainContainer">
      <div className="container mt-4">
        <h2>Publisher Domains</h2>
        {message && <div className="alert alert-info">{message}</div>}
        <button
          className="btn btn-success mb-3 mx-2"
          onClick={() => navigate(`/add-domain/${pubId}`)}
        >
          + Add Domain
        </button>
        <button
         className="btn btn-warning btn-md mx-2 mb-3"
           onClick={() => navigate(`/ad-list/${pubId}`)}>
           Manage Ad Units
        </button>
        <button
         className="btn btn-primary btn-md mx-2 mb-3"
           onClick={() => navigate(`/update-other-setting/${pubId}`)}>
           Update Other Settings
        </button>
      <table className="table table-striped table-hover table-bordered">
                <thead>
            <tr>
              <th scope="col">S.N </th>
              <th scope="col">Domain Name</th>
              <th scope="col">Publisher Name</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {
              domainList?.length > 0 ? (
                  domainList.map((domainList, domainListInd) =>(
                  <tr key={domainListInd}>
                    <td>{domainListInd + 1}</td>
                    <td>{domainList.domain}</td>
                    <td>{domainList.name}</td>
                    <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => navigate(`/edit-domain/${domainList.account_id}/${domainList.id}`)}
                      >
                      Edit domain
                    </button>
                    {/* <button
                      className="btn btn-success btn-md mx-2"
                      onClick={() => navigate(`/create-ad/${domainList.account_id}/${domainList.id}`)}
                    >
                      Creat Ads
                    </button> */}
                    </td>
                  </tr>
                ))
              ) : 
              <tr>
                <td colSpan="12" className="text-center">No data available</td>
              </tr>
            }
          </tbody>
      </table>
      </div>
    </section>
  )
}

export default DomainsList;